module.exports = __webpack_public_path__ + "img/3.49ca4b29.jpeg";